import { QueryObserverResult, useQuery } from '@tanstack/react-query'
import groupBy from 'lodash/groupBy'
import { Submission, SubmissionName } from '@global/types'
import { api } from 'api'

export type SubmissionPartial = Pick<SubmissionName, 'submission_id' | 'submission_name'>

type SubmissionsResponse = Record<string, SubmissionPartial[]>

export function useSubmissionPartials(
  templateId: number,
): QueryObserverResult<SubmissionsResponse, Error> {
  async function getSubmissions(): Promise<SubmissionsResponse> {
    const params = {
      template_id: templateId,
      order_by: 'created_at',
      order: 'desc',
      offset: 0,
    }

    const { data } = await api.get<(SubmissionName | Submission)[]>(
      `/api/core/v1/submissions/template/${templateId}`,
      {
        params,
      },
    )

    const submissionPartials = data.map(sub => ({
      submission_id: sub.submission_id,
      submission_name: sub.submission_name || '[Untitled]',
    }))

    return groupBy(submissionPartials, 'submission_name')
  }

  return useQuery({
    queryKey: ['getSubmissions', templateId],
    queryFn: getSubmissions,
    enabled: Boolean(templateId),
    refetchOnWindowFocus: false,
  })
}
